/**
 * Default values if not provided.
 */
export const TEXT_SPIN_BUTTON_DEFAULTS = {
  SMALL_STEP: 1, // Step size for arrow up/down keys.
  BIG_STEP: 5, // Step size for page up/down keys.
  VALUE: '',
} as const;
